import request from '@/utils/request'

// 获取用户权限列表
export function getUserPermissions() {
  return request({
    url: '/api/auth/user-permissions',
    method: 'get'
  })
}

// 检查用户是否有指定权限
export function checkPermission(permission) {
  return request({
    url: '/api/auth/check-permission',
    method: 'post',
    data: { permission }
  })
}

// 获取所有权限列表
export function getAllPermissions() {
  return request({
    url: '/api/admin-roles/all-permissions',
    method: 'get'
  })
}

// 获取用户自定义权限
export function getUserCustomPermissions(userId) {
  return request({
    url: `/api/admin-users/${userId}/custom-permissions`,
    method: 'get'
  })
}

// 保存用户自定义权限
export function saveUserCustomPermissions(userId, data) {
  return request({
    url: `/api/admin-users/${userId}/custom-permissions`,
    method: 'post',
    data
  })
}